<template>
  <div class="section" :class="$mq">
    <div class="title">{{ $t("step3.provider.title") }}</div>
    <div class="container inline city">
      <label for="providerElec" v-if="hasElec">
        <h4>{{ $t("step3.provider.elec") }}</h4>
        <div class="inline h-item-margin center">
          <span class="unit-text" :class="{TA:isTestAchat}"><SvgIcon class="energy" :class="{TA:isTestAchat}" icon="elec" fill></SvgIcon></span>
          <SelectField
            id="providerElec"
            name="providerElec"
            :unit="true"
            v-model="providerElec"
            :disabled="loading"
            :options="providersElec"
          >

          <option
              v-for="provider in providersElec"
              :data-selected="provider.id === providerElec"
              :key="provider.id"
              v-bind:value="provider.id"
            >{{ provider.name }}</option>
        </SelectField>
        </div>
      </label>

      <label for="providerGas" v-if="hasGas">
        <h4>{{ $t("step3.provider.elec") }}</h4>
        <div class="inline h-item-margin center">
          <span class="unit-text" :class="{TA:isTestAchat}"><SvgIcon class="energy" :class="{TA:isTestAchat}" icon="gas" fill></SvgIcon></span>
          <SelectField
            id="providerGas"
            name="providerGas"
            :unit="true"
            v-model="providerGas"
            :disabled="loading"
          >
            <option
              v-for="provider in providersGas"
              :data-selected="provider.id === providerGas"
              :key="provider.id"
              v-bind:value="provider.id"
            >{{ provider.name }}</option>
          </SelectField>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectField from "@/components/Form/SelectField.vue";
export default {
    props: {
        loading: Boolean
    },
    computed: {
        ...mapGetters("energy", ["hasElec", "hasGas"]),
        ...mapGetters("common", ["isTestAchat"]),
        providersElec() {
            return this.$store.state.calculation.providersElec.sort((a, b) => a.name < b.name ? -1 : 1);
        },
        providersGas() {
            return this.$store.state.calculation.providersGas.sort((a, b) => a.name < b.name ? -1 : 1);
        },
        providerElec: {
            get() {
                return this.$store.state.calculation.providerElec;
            },
            set(value) {
                this.$store.commit("calculation/setProviderElec", value);
            }
        },
        providerGas: {
            get() {
                return this.$store.state.calculation.providerGas;
            },
            set(value) {
                this.$store.commit("calculation/setProviderGas", value);
            }
        }
    },
    components: { SelectField }
};
</script>

<style lang="scss" scoped>
.energy {
  font-size: 1rem;
  color: $black;

  &.TA {
    color: $white;
  }
}

.unit-text {
  border-radius: 4px 0px 0px 4px!important;
  padding: 6px 0px!important;
}

.input {
  border-radius: 0px 4px 4px 0px!important;
  min-width: 250px;
}


select:disabled {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/views/calculation/Providers.vue